export default __webpack_public_path__ + "static/media/pdfIcon.3605161a.svg";